import { drawnPlotKeys } from "./indicatorValues";

// What the list event and engine.getIndicators() tell about an indicator
const describe = (instance) => ({
  key: instance.key,
  id: instance.definition.id,
  name: instance.definition.name,
  isOscillator: instance.definition.isOscillator,
  paneId: instance.paneId,
  inputs: instance.inputs,
  styles: instance.styles,
  isVisible: instance.isVisible,
  plotKeys: drawnPlotKeys(instance.definition),
});

/**
 * Indicator instances in the order they were added, and listeners of
 * the list: they get the described list at once and after every change.
 *
 * @param {() => void} invalidate - a change also schedules a frame
 */
export const createIndicatorList = (invalidate) => {
  const instances = [];
  const listeners = new Set();

  const describeAll = () => instances.map(describe);

  return {
    instances,

    /** @returns {object|null} */
    find: (key) => instances.find((instance) => instance.key === key) || null,

    describeAll,

    /** Tells the listeners and redraws. */
    changed: () => {
      const snapshot = describeAll();

      listeners.forEach((listener) => listener(snapshot));
      invalidate();
    },

    /**
     * @param {(indicators: object[]) => void} listener
     * @returns {() => void} unsubscribes
     */
    subscribe: (listener) => {
      listeners.add(listener);
      listener(describeAll());

      return () => listeners.delete(listener);
    },

    clear: () => {
      instances.forEach((instance) => instance.release());
      instances.length = 0;
      listeners.clear();
    },
  };
};
